import React, {
    PureComponent
} from 'react';
import AnimatedView from '../../../components/componentsGeneral/AnimatedView/AnimatedView';
import ShipmentDetailsContainer from '../../../components/componentsControlTower/ShipmentDetails/ShipmentDetailsContainer';

class ctrlTwrShipmentDetailsManagementView extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {

        };
    }


    componentDidMount() {

    }

    render() {

        return (
            <AnimatedView>
                <ShipmentDetailsContainer isMobile={this.props.isMobile} warehouseSelection={this.props.warehouseSelection} customerSelection={this.props.customerSelection} organizationSelection={this.props.organizationSelection}/>
            </AnimatedView>

        );
    }
}

export default ctrlTwrShipmentDetailsManagementView;
